import styled from 'styled-components';

export const NotFoundPopup = styled.div(props=>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 689px;
    height: 242px;
    padding: 40px;
    border-radius: 16px;
    background-color: #ffffff;
    .notFoundPopupHeading {
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
        font-family: ${props.theme && props.theme.font.fontFamily};
        font-size: ${props.theme && props.theme.font.custom(24)};
        font-weight: bold;
        margin-bottom: 10px;
    }
    p:not(.notFoundPopupHeading) {
        font-family: Roboto;
        font-size: 16px;
        color: ${props.theme ? props.theme.colors.downriver.medium : '#46484d'};
    }
    div {
        width: 133px;
        height: 36px;
        padding: 8px 40px;
        border-radius: 8px;
        background-color: #e8f3ff;
        margin-top: auto;
        font-family: ${props.theme && props.theme.font.fontFamily};
        font-size: ${props.theme && props.theme.font.custom(16)};
        color: #2276e3;
        font-weight: bold;
        cursor:pointer;
    }
`);
